module.exports = __webpack_public_path__ + "static/media/success_payment.0ed4e535.png";